<template>
  <div class="mid_scroll_content portfolioPage">
    <!-- <loader v-show="pageLoader"></loader> -->
    <section class="cap_exhange_cur h-100 border-0">
      <div class="row justify-content-between">
        <div class="col-12 col-lg-7 my-lg-4">
          <h3 v-if="get_user.profile.firstname">
            {{ get_user.profile.firstname + "’s" }} Portfolio
          </h3>
          <p>Here you can find all information about your crypto portfolio</p>
        </div>
        <div
          class="col-12 col-lg-5 my-lg-4 d-flex align-items-center justify-content-end mobSpace"
        >
          <div class="position-relative filterButotn d-inline-flex">
            <a
              @click.prevent="filter = !filter"
              href="javascript:void(0)"
              class="d-flex align-items-center"
            >
              <feather type="sliders"></feather
              ><span class="mx-2">Filters by Information</span
              ><feather type="chevron-down"></feather>
            </a>
            <ul
              class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
              :class="filter ? 'show' : ''"
            >
              <li>
                <label class="customCheckbox">
                  ROI Percentage
                  <input type="checkbox" name="date" value="1" />
                  <span class="checkmark"></span>
                </label>
              </li>
              <li>
                <label class="customCheckbox">
                  Asset Details
                  <input type="checkbox" name="date" value="2" />
                  <span class="checkmark"></span>
                </label>
              </li>
              <li>
                <label class="customCheckbox">
                  Portfolio Allocation
                  <input type="checkbox" name="date" value="3" />
                  <span class="checkmark"></span>
                </label>
              </li>
              <li>
                <label class="customCheckbox">
                  Portfolio Net Worth
                  <input type="checkbox" name="date" value="4" />
                  <span class="checkmark"></span>
                </label>
              </li>
              <li>
                <label class="customCheckbox">
                  My Assets
                  <input type="checkbox" name="date" value="4" />
                  <span class="checkmark"></span>
                </label>
              </li>
              <li>
                <label class="customCheckbox">
                  Cumulative P/L
                  <input type="checkbox" name="date" value="4" />
                  <span class="checkmark"></span>
                </label>
              </li>
            </ul>
          </div>
          <change-account class="ml-3"></change-account>
        </div>
        <div class="col-12 col-xl-5 mb-3 mb-md-5 mb-4">
          <div class="holdingData">
            <span class="d-block text-right mb-3"
              ><a href="javascript:void(0)" class="closeBlock"
                ><feather type="x"></feather></a
            ></span>
            <div class="d-flex justify-content-between">
              <div class="blockElemnt border-right w-50 mr-4">
                <div class="holdingValue mb-4">
                  <p class="f-14">Holding Value</p>
                  <h2 class="mb-0 secondary">
                    ${{ formatPrice(totalUsdValue) }}
                  </h2>
                </div>
                <!-- <div class="holdingValue">
                  <p>Invested Amount</p>
                  <h3 class="mb-0 themecolor">
                    9,500<sub class="f-12">USD</sub>
                  </h3>
                </div> -->
              </div>
              <div class="blockElemnt w-50 pl-4">
                <p
                  class="f-14 d-flex align-items-center justify-content-between"
                >
                  Profit & Loss (P/L)
                  <span :class="todaysPnl > 0 ? 'green' : 'red'"
                    >{{ formatPrice(todaysPnlPercentage) }}%</span
                  >
                </p>
                <div
                  class="d-flex align-items-center justify-content-between mb-4"
                >
                  <feather
                    v-if="todaysPnl > 0"
                    class="ml-1"
                    type="trending-up"
                  ></feather
                  ><feather
                    v-if="todaysPnl < 0"
                    class="ml-1"
                    type="trending-down"
                  ></feather>
                  <h3>
                    ${{ formatPrice(todaysPnl) }}
                  </h3>
                </div>
                <!-- <div class="d-flex align-items-center justify-content-between">
                  <div class="pAdd">
                    <p class="f-14">Port. Return</p>
                    <h3 class="d-block">7.5%</h3>
                  </div>
                  <div class="pAdd">
                    <p class="f-14">Total ROI%</p>
                    <h3 class="d-block">68%</h3>
                  </div>
                </div> -->
              </div>
            </div>
            <div
              class="submitButton d-flex align-items-center justify-content-center my-4"
            >
              <router-link
                :to="{ path: '/deposit-withdrawal', query: { deposit: 'BTC' } }"
                href="javascript:void(0)"
                class="cap_btn lg mr-3"
                >Deposit</router-link
              >
              <router-link
                :to="{
                  path: '/deposit-withdrawal',
                  query: { withdraw: 'BTC' },
                }"
                href="javascript:void(0)"
                class="cap_btn border-btn lg"
                >Withdraw</router-link
              >
            </div>
            <p class="themecolor">
              Total of Crypto Assets:
              <strong>{{ curencyUsdValList.length }} Assets</strong>
            </p>
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3 mb-md-5 mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="semibold mb-3">Portfolio Allocation</h3>
            <a href="javascript:void(0)" class="closeBlock"
              ><feather type="x"></feather
            ></a>
          </div>
          <div class="chartPortfolio mt-4">
            <currencyChart
              style="height: 230px"
              :currency_list="curencyUsdValList"
              :from="'portfolio'"
            />
            <!-- <div class="d-flex align-items-center justify-content-between">
							<div class="circleChartBlock">
								<img src="../../../../static/website/images/fullChart.svg" alt="aim chart" title="aim chart">
							</div>
							<ul class="valueChart d-flex flex-wrap justify-content-between">
								<li class="c2">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>BTC </p>
									<p class="mb-0">35%</p>
								</li>
								<li class="ada">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>ADA </p>
									<p class="mb-0">9.8%</p>
								</li>
								<li class="green">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>USDT </p>
									<p class="mb-0">22%</p>
								</li>
								<li class="eth">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>ETH </p>
									<p class="mb-0">12%</p>
								</li>
								<li class="textcolor">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>LTC </p>
									<p class="mb-0">18%</p>
								</li>
								<li class="yellow">
									<p class="d-flex align-items-center mb-0"><span class="dot"></span>DOGE </p>
									<p class="mb-0">3.2%</p>
								</li>
							</ul>
						</div> -->
          </div>
        </div>
        <div class="col-12 col-xl-5 mb-md-5 mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="semibold mb-3">Asset Details</h3>
            <a href="javascript:void(0)" class="closeBlock"
              ><feather type="x"></feather
            ></a>
          </div>
          <div
            class="carouselSlide mt-4"
            v-if="Object.keys(margin_list).length > 0"
          >
            <VueSlickCarousel v-bind="settings" :arrows="true">
              <div
                class="card-body p-0 text-center"
                :class="(index + 1) % 2 == 1 ? 'secondaryBG' : ''"
                v-for="(item, key, index) in margin_list" v-if="parseFloat(item.amount)!=0"
              >
                <div class="content p-3">
                  <!-- <img class="mb-3 d-block mx-auto" width="40" src="../../../../static/website/images/crypto_logos/ltc.png" alt="Icon"> -->
                  <img
                    class="mb-3 d-block mx-auto"
                    :src="
                      '../../../../static/website/images/crypto_logos/' +
                      item.currency.toLowerCase() +
                      '.png'
                    "
                    @error="handleImgErr($event)"
                    :alt="item.currency"
                    v-if="isImage(item.currency.toLowerCase())"
                  />
                  <span class="firstName" v-else>{{
                    item.currency.charAt(0)
                  }}</span>
                  <p
                    class="mb-0 f-13 semibold"
                    :class="(index + 1) % 2 == 1 ? 'text-white' : ''"
                  >
                    {{ getCurrName(item.currency) }} ({{ item.currency }})
                  </p>
                  <h5
                    class="medium mt-2"
                    :class="(index + 1) % 2 == 1 ? 'text-white' : ''"
                  >
                    ${{ formatPrice(getConvertedValue(item, "USD")) }}
                    
                  </h5>
                  <!-- <span class="text-white f-10 hTrade greenBG">+ 0.89</span> -->
                </div>
                <!-- <div class="footerGraph"><img class="m-0 w-100" src="../../../../static/website/images/whitechart.svg" alt="Graph"></div> -->
              </div>
              <!-- <div class="card-body p-0 secondaryBG text-center">
					      		<div class="content p-3">
					      			<img class="mb-3 d-block mx-auto" width="40" src="../../../../static/website/images/crypto_logos/ltc.png" alt="Icon">
									<p class="text-white mb-0 f-13 semibold">Litecoin (LTC)</p>
									<h5 class="text-white medium mt-2">112.95 USD</h5>
									<span class="text-white f-10 hTrade greenBG">+ 0.89</span>
								</div>
								<div class="footerGraph"><img class="m-0 w-100" src="../../../../static/website/images/whitechart.svg" alt="Graph"></div>
							</div>
							<div class="card-body p-0 text-center">
					      		<div class="content p-3">
					      			<img class="mb-3 d-block mx-auto" width="40" src="../../../../static/website/images/crypto_logos/eth.png" alt="Icon">
									<p class="mb-0 f-13 semibold">Ethereum (ETH)</p>
									<h5 class="medium mt-2">3,262.94 USD</h5>
									<span class="text-white f-10 hTrade themeBG">+ 0.89</span>
								</div>
								<div class="footerGraph"><img class="m-0 w-100" src="../../../../static/website/images/themechart.svg" alt="Graph"></div>
							</div>
							<div class="card-body p-0 secondaryBG text-center">
					      		<div class="content p-3">
					      			<img class="mb-3 d-block mx-auto" width="40" src="../../../../static/website/images/crypto_logos/ltc.png" alt="Icon">
									<p class="text-white mb-0 f-13 semibold">Litecoin (LTC)</p>
									<h5 class="text-white medium mt-2">112.95 USD</h5>
									<span class="text-white f-10 hTrade greenBG">+ 0.89</span>
								</div>
								<div class="footerGraph"><img class="m-0 w-100" src="../../../../static/website/images/whitechart.svg" alt="Graph"></div>
							</div>
							<div class="card-body p-0 text-center">
					      		<div class="content p-3">
					      			<img class="mb-3 d-block mx-auto" width="40" src="../../../../static/website/images/crypto_logos/eth.png" alt="Icon">
									<p class="mb-0 f-13 semibold">Ethereum (ETH)</p>
									<h5 class="medium mt-2">3,262.94 USD</h5>
									<span class="text-white f-10 hTrade themeBG">+ 0.89</span>
								</div>
								<div class="footerGraph"><img class="m-0 w-100" src="../../../../static/website/images/themechart.svg" alt="Graph"></div>
							</div> -->
            </VueSlickCarousel>
          </div>
        </div>
        <div class="col-12 col-xl-6 mb-3 mb-md-5 mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="semibold mb-3">ROI Percentage (%)</h3>
            <a href="javascript:void(0)" class="closeBlock"
              ><feather type="x"></feather
            ></a>
          </div>
          <div class="roiPercentage mt-4">
            <ul class="mb-0">
              <li v-for="wallet of accountsWithMargin">
                <p class="mb-0 themecolor">
                  {{ getCurrName(wallet.currency) }} ({{ wallet.currency }})
                </p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div
                      class="progress-bar"
                      :style="
                        'width: ' +
                        (getROI(wallet) > 100 ? 100 : getROI(wallet)) +
                        '%'
                      "
                    ></div>
                  </div>
                  <p class="mb-0" :class="{ red: getROI(wallet) < 0 }">
                    {{ formatPrice(getROI(wallet)) }}%
                  </p>
                </div>
              </li>
              <!-- <li>
                <p class="mb-0 themecolor">Tether (USDT)</p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div class="progress-bar" style="width: 30%"></div>
                  </div>
                  <p class="mb-0">30%</p>
                </div>
              </li>
              <li>
                <p class="mb-0 themecolor">Litecoin (LTC)</p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div class="progress-bar" style="width: 50%"></div>
                  </div>
                  <p class="mb-0">50%</p>
                </div>
              </li>
              <li>
                <p class="mb-0 themecolor">Cardano (ADA)</p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div class="progress-bar" style="width: 70%"></div>
                  </div>
                  <p class="mb-0">70%</p>
                </div>
              </li>
              <li>
                <p class="mb-0 themecolor">Ethereum (ETH)</p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div class="progress-bar" style="width: 30%"></div>
                  </div>
                  <p class="mb-0">30%</p>
                </div>
              </li>
              <li>
                <p class="mb-0 themecolor">Dogecoin (DOGE)</p>
                <div class="d-flex align-items-center barCal">
                  <div class="progress mr-2">
                    <div class="progress-bar" style="width: 10%"></div>
                  </div>
                  <p class="mb-0">11.23%</p>
                </div>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="col-12 mb-3 mb-lg-5 mb-md-5 mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="semibold mb-3">Portfolio Net Worth</h3>
            <span class="d-block text-right ml-3"
              ><a href="javascript:void(0)" class="closeBlock"
                ><feather type="x"></feather></a
            ></span>
          </div>
          <div class="tetherChart mt-4">
            <div
              class="chartHeader p-3 d-flex align-items-center justify-content-between"
            >
              <div class="position-relative filterButotn d-inline-flex">
                <a
                  @click.prevent="filter = !filter"
                  href="javascript:void(0)"
                  class="d-flex align-items-center"
                >
                  <span class="mx-2">All Currencies</span
                  ><feather type="chevron-down"></feather>
                </a>
                <ul
                  class="dropdown_menu dropdown_menu--animated dropdown_menu-6 left-auto"
                  :class="filter ? 'show' : ''"
                >
                  <li>
                    <label class="customCheckbox">
                      BTC
                      <input type="checkbox" name="date" value="2" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                  <li>
                    <label class="customCheckbox">
                      USDT
                      <input type="checkbox" name="date" value="3" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                  <li>
                    <label class="customCheckbox"
                      >ETH
                      <input type="checkbox" name="date" value="4" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                  <li>
                    <label class="customCheckbox">
                      BTH
                      <input type="checkbox" name="date" value="4" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                  <li>
                    <label class="customCheckbox">
                      LTC
                      <input type="checkbox" name="date" value="4" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                   <li>
                    <label class="customCheckbox">
                      USD
                      <input type="checkbox" name="date" value="5" />
                      <span class="checkmark"></span>
                    </label>
                  </li>
                </ul>
              </div>
              <div class="rightElement d-flex align-items-center">
                <ul class="d-flex align-items-center chartYear mr-3 mb-0">
                  <li>
                    <a
                      @click.prevent="charTab = 'date'"
                      :class="charTab == 'date' ? 'active' : ''"
                      href="javascript:void(0)"
                    >
                      D</a
                    >
                  </li>
                  <li>
                    <a
                      @click.prevent="charTab = 'week'"
                      :class="charTab == 'week' ? 'active' : ''"
                      href="javascript:void(0)"
                    >
                      W</a
                    >
                  </li>
                  <li>
                    <a
                      @click.prevent="charTab = 'month'"
                      :class="charTab == 'month' ? 'active' : ''"
                      href="javascript:void(0)"
                    >
                      M</a
                    >
                  </li>
                  <li>
                    <a
                      @click.prevent="charTab = 'year'"
                      :class="charTab == 'year' ? 'active' : ''"
                      href="javascript:void(0)"
                    >
                      Y</a
                    >
                  </li>
                </ul>
                <div class="form-group mb-0">
                  <input type="date" class="form-control small" name="" />
                </div>
                <p class="mx-3 mb-0">To</p>
                <div class="form-group mb-0">
                  <input type="date" class="form-control small" name="" />
                </div>
              </div>
            </div>
            <div class="chart">
              <wallets-chart />
              <!-- <img
                src="../../../../static/website/images/portfolio-net-worth.svg"
                alt="Chart"
                title="Chart"
                class="w-100"
              /> -->
            </div>
          </div>
        </div>
        <!-- <div class="col-12 mb-3 mb-md-5">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h3 class="semibold">My Assets</h3>
            <div class="d-flex align-items-center">
              <div
                class="form-group position-relative includeIco searchTable mb-0"
              >
                <input
                  type="text"
                  placeholder="Search all Cryptos"
                  name="legal_name"
                  class="form-control small"
                />
                <span class="searchIco"><feather type="search"></feather></span>
              </div>
              <span class="d-block text-right ml-3"
                ><a href="javascript:void(0)" class="closeBlock"
                  ><feather type="x"></feather></a
              ></span>
            </div>
          </div>
          <div class="myAssets border position-relative border-radius-15 mt-4">
            <div class="marketData table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Asset</th>
                    <th>Quantity</th>
                    <th>Invested Amount</th>
                    <th>Current USD Val.</th>
                    <th>P/L</th>
                    <th>24h Change</th>
                    <th>Current Price</th>
                    <th>ROI%</th>
                    <th>Daily ROI%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in margin_list">
                    <td>
                      <span class="d-flex align-items-center">
                        <span class="inTableIcon ml-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              item.currency.toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="item.currency"
                            v-if="isImage(item.currency.toLowerCase())"
                          />
                          <span class="firstName" v-else>{{
                            item.currency.charAt(0)
                          }}</span>
                        </span>
                        <div class="iqlName">
                          <p class="mb-0 themecolor medium">
                            {{ item.currency }}
                          </p>
                          <p class="f-10 mb-0">
                            {{ getCurrName(item.currency) }}
                          </p>
                        </div>
                      </span>
                    </td>
                    <td>{{ item.amount || "-" }}</td>
                    <td>-</td>
                    <td>
                      <span v-if="item.amount && getConvertedValue(item, 'USD')"
                        >${{
                          parseFloat(getConvertedValue(item, "USD")).toFixed(3)
                        }}</span
                      >
                      <span v-else>N/A</span>
                    </td>
                    <td class="green">-</td>
                    <td>
                      <span class="d-flex align-items-center green">
                        <feather
                          class="mr-1"
                          size="17px"
                          type="trending-up"
                        ></feather
                        >-
                      </span>
                    </td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-12 mb-3 mb-md-5">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="semibold mb-3">Cumulative P/L</h3>
            <span class="d-block text-right ml-3"
              ><a href="javascript:void(0)" class="closeBlock"
                ><feather type="x"></feather></a
            ></span>
          </div>
          <div class="myAssets border position-relative border-radius-15 mt-4">
            <div class="marketData table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th align="center">Daily Profit and Loss</th>
                    <th align="right">Cumulative Profit and Loss</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2022/04/05</td>
                    <td align="center">-1.74 $</td>
                    <td align="right" class="green">27.17 $</td>
                  </tr>
                  <tr>
                    <td>2022/04/01</td>
                    <td align="center">-3.69 $</td>
                    <td align="right" class="green">28.91 $</td>
                  </tr>
                  <tr>
                    <td>2022/03/22</td>
                    <td align="center">7.28 $</td>
                    <td align="right" class="green">32.45 $</td>
                  </tr>
                  <tr>
                    <td>2022/03/15</td>
                    <td align="center">-3.12 $</td>
                    <td align="right" class="green">25.16 $</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>
<!-- <style>
  button.slick-prev:before, button.slick-next:before {
      background-color: #0A1856 !important;
}
</style> -->
<script>
// import commonAllMixins from '@/plugins/commonAll';
import tradingMixins from "@/plugins/trading";
import VueSlickCarousel from "vue-slick-carousel";
import currencyChart from "../shared/chart/currencyChart";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import walletsChart from "../shared/chart/walletsChart";

export default {
  name: "Portfolio",
  mixins: [tradingMixins],
  data() {
    return {
      filter: false,
      currencies: false,
      charTab: "date",
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold: 5,
      },
      curencyUsdValList: [],
      margin_list: {},
      errImage: [],
    };
  },
  watch: {
    tradingAccount(value) {
      if (!parseInt(this.accountSelected)) {
        this.getCurrency(value);
      }
    },
    socialAccount(value) {
      if (parseInt(this.accountSelected) == 1) {
        this.getCurrency(value);
      }
    },
  },
  components: { VueSlickCarousel, currencyChart, walletsChart },
  methods: {
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    changeCurencyUsdValList() {
      this.currencyData();
      setTimeout(() => {
        this.currencyData();
      }, 5000);
    },
    currencyData() {
      try {
        this.curencyUsdValList = [];
        for (const item in this.margin_list) {
          let index = this.curencyUsdValList
            .map((e) => e.currency)
            .indexOf(this.margin_list[item].currency);
          if (index == -1) {
            this.curencyUsdValList.push({
              currency: this.margin_list[item].currency,
              usdValue: this.getConvertedValue(this.margin_list[item], "USD"),
            });
          } else {
            this.curencyUsdValList[index]["usdValue"] = this.getConvertedValue(
              this.margin_list[item],
              "USD"
            );
          }
        }
        this.curencyUsdValList.sort(function (a, b) {
          return parseFloat(b.usdValue) - parseFloat(a.usdValue);
        });
      } catch (e) {
        setTimeout(() => {
          this.currencyData();
        }, 1000);
      }
    },
    getCurrency(value) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        /*this.currency = value[0].subAccounts[0]
				let btcPair = value[0].subAccounts.map(val=>val.currency + '-BTC')
				let usdPair = value[0].subAccounts.map(val=>val.currency + '-USD')
				this.subscribPairs(btcPair.concat(usdPair))*/
        this._runGetMarginInfo({
          globalParams: { account_id: value[0].account_id },
          localParams: { parameter: this, page: "portfolio" },
        });
      }
    },
    subscribPairs(pairList) {
      try {
        if (pairList.length > 0) {
          this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
            "S_PF_PF"
          ].subscribe(pairList);
        }
      } catch (e) {
        setTimeout(() => {
          this.subscribPairs(pairList);
        }, 1000);
      }
    },
    getConvertedValue(item, currency) {
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          return 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue = this.instruments["BTC-" + currency];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue = this.instruments["USD-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
    getROI(wallet) {
      
      // console.log("wallet====<", wallet.holdingPrice);

      if (wallet.holdingPrice) {

        // console.log(this.$env_var.walletCurrencyList)

        let currencyDetail = Object.values(this.$env_var.walletCurrencyList);
        let list = currencyDetail.find((i) => i.symbol == wallet.currency);
        if (!list || (list && list.keyType != "FIAT")) {
          let initialValue = wallet.holdingPrice * wallet.freemargin;
          let currentValue = 0;
          if (this.instruments[`${wallet.currency}-USD`]) {
            currentValue = this.instruments[`${wallet.currency}-USD`].A;
          } else if (this.instruments[`${wallet.currency}-USDT`]) {
            currentValue = this.instruments[`${wallet.currency}-USDT`].A;
          } else if (this.instruments[`USDT-${wallet.currency}`]) {
            currentValue = 1 / this.instruments[`${wallet.currency}-USDT`].A;
          } else if (
            this.instruments[`${wallet.currency}-BTC`] &&
            this.instruments[`BTC-USD`]
          ) {
            currentValue =
              this.instruments[`${wallet.currency}-BTC`].A /
              this.instruments[`BTC-USD`].A;
          } else if (
            this.instruments[`BTC-${wallet.currency}`] &&
            this.instruments[`BTC-USD`]
          ) {
            currentValue =
              1 /
              this.instruments[`BTC-${wallet.currency}`].A /
              this.instruments[`BTC-USD`].A;
          }

          currentValue = currentValue * wallet.freemargin;

          console.log(((currentValue - initialValue) / initialValue) * 100);

          return ((currentValue - initialValue) / initialValue) * 100;
        }
      }
      return 0;
    },
  },
  computed: {
    accountsWithMargin() {
      let obj = {};
      let currencyDetail = Object.values(this.$env_var.walletCurrencyList);
      // console.log(this.tradingAccount[0].subAccounts);
      for (let key in this.margin_list) {
        let list = currencyDetail.find(
          (i) => i.symbol == this.margin_list[key].currency
        );
        if (
          this.margin_list[key].freemargin > 0 &&
          (!list || (list && list.keyType != "FIAT"))
        ) {
          obj[key] = this.margin_list[key];
        }
      }
      return obj;
    },
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalUsdValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(this.margin_list[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        return "N/A";
      }
    },
    todaysPnl() {
      if (
        this.totalUsdValue > 0 &&
        this.portfolioReport.length &&
        this.curencyUsdValList.length
      ) {
        let pnl = 0;
        let finalData = {};
        for (let item of this.portfolioReport) {
          let value = parseInt(item.BalanceUSD);
          // let date = moment(item.Date).format("x");
          let date = new Date(item.Date).getTime();
          // console.log(date, new Date(item.Date).getTime());
          if (finalData[item.Currency]) {
            finalData[item.Currency].push({
              value,
              date,
            });
          } else {
            finalData[item.Currency] = [
              {
                value,
                date,
              },
            ];
          }
        }
        for (let key in this.margin_list) {
          if (finalData[this.margin_list[key].currency]) {
            finalData[this.margin_list[key].currency].sort((a, b) => {
              return b.date - a.date;
            });
            pnl +=
              parseFloat(this.getConvertedValue(this.margin_list[key], "USD")) -
              parseFloat(finalData[this.margin_list[key].currency][0].value);
          }
        }
        return pnl;
      } else {
        return 0;
      }
    },
    yesterdaysValue() {
      if (this.portfolioReport.length) {
        let finalData = {};
        let pnl = 0;
        for (let item of this.portfolioReport) {
          let value = parseInt(item.BalanceUSD);
          // let date = moment(item.Date).format("x");
          let date = new Date(item.Date).getTime();
          // console.log(date, new Date(item.Date).getTime());
          if (finalData[item.Currency]) {
            finalData[item.Currency].push({
              value,
              date,
            });
          } else {
            finalData[item.Currency] = [
              {
                value,
                date,
              },
            ];
          }
        }
        for (let key in finalData) {
          if (finalData[key]) {
            finalData[key].sort((a, b) => {
              return b.date - a.date;
            });
            pnl += parseFloat(finalData[key][0].value);
          }
        }
        return pnl;
      } else {
        return 0;
      }
    },
    todaysPnlPercentage() {
      // return 1;
      // console.log(this.totalBtcValue / (this.totalBtcValue + this.todaysPnl));
      return (this.todaysPnl / this.yesterdaysValue) * 100;
    },
  },
  created() {
    this.pageName("Portfolio");
    if (parseInt(this.accountSelected) == 1) {
      this.getCurrency(this.socialAccount);
    } else {
      this.getCurrency(this.tradingAccount);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/portfolio/portfolio.vue